import operate from './operate'

export default function () {
  const { scoringMethod } = this.reviewGroupInfo
  const field = scoringMethod === 'DFFS03' ? 'reviewRank' : (scoringMethod === 'DFFS02' ? 'reviewVoteNum' : 'reviewScore')
  let minScore = 0
  let maxScore = 100
  if (scoringMethod === 'DFFS01') {
    minScore = this.reviewGroupInfo.lowestScore || 0
    maxScore = this.reviewGroupInfo.highestScore || 100
  } else if (scoringMethod === 'DFFS02') {
    maxScore = this.reviewGroupInfo.maxVote || 100
  }
  const titleMap = {
    'BOE_REPORT_LIST': '项目名称',
    'BOE_REPORT_LIST_JCBDLX01': '姓名',
    'BOE_REPORT_LIST_JCBDLX02': '团队名称',
    'BOE_REPORT_LIST_JCBDLX03': '组织名称',
    'BOE_REPORT_LIST_JCBDLX04': '项目名称',
    'BOE_REPORT_LIST_JCBDLX05': '社会荣誉名称',
    'BOE_EVENT_INFO': '活动名称'
  }
  return [
    {
      title: titleMap[this.businessCode],
      [$field]: 'objectName'
    },
    {
      title: '轮次序号',
      [$field]: 'reviewRoundNum',
      width: 150
    },
    {
      title: scoringMethod === 'DFFS03' ? '定级' : (scoringMethod === 'DFFS02' ? '投票' : '打分'),
      [$field]: field,
      width: 150,
      render: (h, {row}) => {
        if (scoringMethod === 'DFFS03') {
          const rankOptionList = Object.keys(this.dictMap[this.rankCode]).map(item => {
            return h('Option', {
              props: {
                label: this.dictMap[this.rankCode][item],
                value: item
              }
            })
          })
          return h('Select', {
            props: {
              value: row[field],
              disabled: this.reportState == '1'
            },
            on: {
              'on-change': (val) => {
                row[field] = val
              }
            }
          }, [...rankOptionList])
        } else {
          return h('InputNumber', {
            props: {
              min: minScore,
              value: row[field],
              max: maxScore,
              readonly: this.reportState == '1'
            },
            style: 'width:100%',
            on: {
              'on-change': (val) => {
                let fieldVal = val + ''
                if (fieldVal.indexOf('.') != -1) {
                  this.$Message.warning('请输入正整数')
                  row[field] = minScore
                  this.tableData[row._index][field] = minScore
                  return
                }
                row[field] = val
              }
            }
          })
        }
      }
    },
    {
      title: '评审意见',
      [$field]: 'reviewOpinion',
      width: 300,
      render: (h, {row}) => {
        return h('Input', {
          props: {
            value: row.reviewOpinion,
            readonly: this.reportState == '1'
          },
          style: 'width:100%',
          on: {
            'on-change': (val) => {
              const target = event.target
              row.reviewOpinion = target.value
            }
          }
        })
      }
    },
    {
      'title': '操作',
      'width': 160,
      [$field]: 'operate',
      'isOperate': true,
      'slotComponent': operate
    }
  ]
}